export const config = {
  url: {
    apiEndPoint: "https://claro.acessoenergia.com.br/api",
    urlUpload: "https://claro.acessoenergia.com.br/api",
    urlPortalLogin: "https://energia.claro.com.br/portal-cliente/login?client=claro",
    urlLogout: "https://claro.acessoenergia.com.br/claro/logout",
    urlPortal: "https://energia.claro.com.br/area-cliente",
    urlLp: "https://energia.claro.com.br/lp",
    urlLoginPortal: "https://energia.claro.com.br/portal-cliente?client=claro",
    urlRedirect: "https://energia.claro.com.br/portal-cliente?client=claro",
    urlEnergyAdvisor: "https://claroenergia.energyadvisor.com.br/energy-advisor"
  },
  simulacao: {
    idCanal: 35,
    situacao: "1",
    idTipoProduto: "1",
    usuarioID: 22749,
    tipoParceiro: 168,
    tipoCanal: 34,
    tipoCanalVendedor: 35,
    idTagCliente: "5",
    idTagNaoCliente: "6",
    idSimuladorTipo: 7,
    dispararSms: true
  },
  loginClaro: {
    claroLoginApi: "https://claro.acessoenergia.com.br/api",
    openIDClaroApi: "https://ipc.claro.com.br/as/authorization.oauth2",
    claroRedirectUri: "https://energia.claro.com.br/lp/auth/callback",
    claroClientId: "ClaroEnergia"
  }
};
